import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Header() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const token = localStorage.getItem("token");

  let payload = null;
  let username = null;
  if (token) {
    try {
      payload = JSON.parse(atob(token.split(".")[1]));
      username = payload.username
      document.title = username + "@rendeléseim.csontho.info"
    } catch { }
  }

  const logout = () => {
    localStorage.removeItem("token");
    window.location = "/";
  };

  const handleMenuItemClick = (path) => {
    setOpen(false); // Close the menu
    navigate(path); // Navigate to the specified path
  };
  return (
    <div className="bg-white shadow p-3 flex justify-between items-center">
      <div
        className="font-bold cursor-pointer"
        onClick={() => handleMenuItemClick("/")}
      >
        <span className="text-blue-500">{username}</span><span className="darkgray text-xs">@</span><span className="text-xs">RENDELÉSEIM</span><span className="darkgray text-xs">.csontho.info</span>
      </div>

      {token && (
        <div className="relative">
          <button
            onClick={() => setOpen(!open)}
            className="bg-gray-200 px-3 py-1 rounded"
          >
            ☰
          </button>

          {open && (
            <div className="absolute right-0 bg-white shadow rounded mt-2 w-40">
              <div
                onClick={() => handleMenuItemClick("/")}
                className="p-2 hover:bg-gray-100 cursor-pointer"
              >
                Rendelések
              </div>

              <div
                onClick={() => handleMenuItemClick("/profile")}
                className="p-2 hover:bg-gray-100 cursor-pointer"
              >
                Profil
              </div>

              {payload?.role === "admin" && (
                <div
                  onClick={() => handleMenuItemClick("/admin")}
                  className="p-2 hover:bg-gray-100 cursor-pointer"
                >
                  Admin
                </div>
              )}

              <div
                onClick={logout}
                className="p-2 hover:bg-gray-100 cursor-pointer text-red-600"
              >
                Kilépés
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}